import Modal from '../shared/Modal';

const HowToPlayModal = ({ 
  isOpen, 
  onClose 
}) => {
  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      title="How to Play"
    >
      <div style={{ textAlign: 'left', padding: '0' }}>
        <p><strong>Objective:</strong></p>
        <p>Complete the puzzle by guessing the next word in the chain.</p>
        <br />
        
        <p><strong>How it works:</strong></p>
        <p>• Each word connects to the previous through word association.</p>
        <p>• Difficulty level determines which hints are provided to help you solve the puzzle.</p>
        <br />
        
        
        <p><strong>Scoring:</strong></p>
        <p>Score = (100 - Incorrect Guesses) × Difficulty Multiplier</p>
        <p>Higher difficulty = higher potential score!</p>
      </div>
    </Modal>
  );
};

export default HowToPlayModal;